{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% sparen)",
    "{amount} days free": "{amount} Tage kostenfrei",
    "{amount} off": "{amount} Rabatt",
    "{amount} off for first {number} months.": "{amount} Rabatt für die ersten {number} Monate.",
    "{amount} off for first {period}.": "{amount} Rabatt für den/das erste/n {period}.",
    "{amount} off forever.": "dauerhaft {amount} günstiger.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% Rabatt",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} wird den Newsletter {newsletterName} nicht länger erhalten.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} wird keine weiteren E-Mail-Benachrichtigungen für Kommentar-Antworten erhalten.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} wird diesen Newsletter nicht länger erhalten.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} Tage kostenfrei",
    "{years} years": "",
    "+1 (123) 456-7890": "+49 123 4567890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konto",
    "Account details updated successfully": "Kontodaten erfolgreich aktualisiert",
    "Account settings": "Konto-Einstellungen",
    "Add a personal note": "Persönliche Anmerkung hinzufügen",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Wenn das kostenlose Testabo endet, bezahlst du den regulären Preis für den gewählten Tarif. Du kannst dein Abonnement jederzeit kündigen.",
    "Already a member?": "Bereits Mitglied?",
    "An error occurred": "Ein Fehler ist aufgetreten",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut oder wende dich an den <a>Support</a>, falls der Fehler weiter besteht.",
    "Back": "Zurück",
    "Back to Log in": "Zurück zur Anmeldung",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Jederzeit kündbar.",
    "Cancel subscription": "Abonnement kündigen",
    "Canceled": "",
    "Cancellation reason": "Kündigungsgrund",
    "Change": "Ändern",
    "Change plan": "Tarif ändern",
    "Check spam & promotions folders": "Überprüfe deine Spam- und Werbeordner",
    "Check with your mail provider": "Erkundige dich bei deinem E-Mail-Anbieter",
    "Check your inbox to verify email update": "Prüfe nun dein E-Mail Postfach, um die Änderung deiner E-Mail Adresse zu bestätigen",
    "Choose": "Auswählen",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Wähle einen anderen Tarif",
    "Choose a plan": "Tarif wählen",
    "Choose a tier": "",
    "Choose your newsletters": "Wähle deine Newsletter",
    "City": "",
    "Click here to retry": "Hier klicken zum Wiederholen",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Schließen",
    "Code": "Bestätigungscode",
    "Comment preferences updated.": "Kommentar-Einstellungen aktualisiert.",
    "Comments": "Kommentare",
    "Complimentary": "Kostenlos",
    "Confirm": "Bestätigen",
    "Confirm cancellation": "Beendigung bestätigen",
    "Confirm subscription": "Abonnement bestätigen",
    "Contact support": "Support kontaktieren",
    "Continue": "Weiter",
    "Continue subscription": "Abonnement fortführen",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Zahlungsabwicklung über Stripe konnte nicht erstellt werden",
    "Could not sign in. Login link expired.": "Anmeldung nicht möglich. Der Login-Link ist abgelaufen.",
    "Could not update email! Invalid link.": "E-Mail-Aktualisierung fehlgeschlagen. Link nicht gültig.",
    "Country": "",
    "Create a new contact": "Neuen Kontakt anlegen",
    "Current plan": "Aktueller Tarif",
    "Delete account": "Konto löschen",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "War das ein Versehen? Verwalte deine Einstellungen <button>hier</button>.",
    "Don't have an account?": "Noch kein Konto?",
    "Edit": "Bearbeiten",
    "Email": "E-Mail",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "E-Mail-Newsletter",
    "Email newsletter settings updated": "E-Mail Newsletter Einstellungen wurden aktualisiert",
    "Email preferences": "E-Mail-Einstellungen",
    "Email preferences updated.": "E-Mail-Einstellungen aktualisiert.",
    "Emails": "E-Mails",
    "Emails disabled": "E-Mails deaktiviert",
    "Ends {offerEndDate}": "Endet am {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "Gib den Bestätigungscode oben ein",
    "Enter the recipient's email address": "",
    "Enter your email address": "Gib deine E-Mail-Adresse ein",
    "Enter your name": "Gib deinen Namen ein",
    "Error": "Fehler",
    "Expires {expiryDate}": "Läuft am {expiryDate} ab",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Abonnement konnte nicht beendet werden. Bitte versuche es erneut.",
    "Failed to log in, please try again": "Login ist fehlgeschlagen. Bitte versuche es erneut.",
    "Failed to log out, please try again": "Abmelden ist fehlgeschlagen. Bitte versuche es erneut.",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Zahlungsabwicklung ist fehlgeschlagen. Bitte versuche es erneut.",
    "Failed to send magic link email": "Magic Link konnte nicht versendet werden",
    "Failed to send verification email": "Bestätigungsmail konnte nicht versendet werden",
    "Failed to sign up, please try again": "Anmeldung ist fehlgeschlagen. Bitte versuche es erneut.",
    "Failed to update account data": "Kontodaten konnten nicht aktualisiert werden",
    "Failed to update account details": "Kontodetails konnten nicht aktualisiert werden",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Newsletter Einstellungen konnten nicht aktualisiert werden",
    "Failed to update subscription, please try again": "Abonnement konnte nicht aktualisiert werden. Bitte versuche es erneut.",
    "Failed to verify code, please try again": "Bestätigungscode konnte nicht verifiziert werden. Bitte versuche es erneut.",
    "For a friend or colleague": "Für Freund*innen oder Kolleg*innen",
    "Forever": "Für immer",
    "Free Trial – Ends {trialEnd}": "Kostenlose Testphase – endet am {trialEnd}",
    "From": "",
    "Get help": "Hilfe erhalten",
    "Get in touch for help": "Kontaktiere uns für Hilfe",
    "Get notified when someone replies to your comment": "Erhalte eine Benachrichtigung, wenn jemand auf deinen Kommentar antwortet",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "Mitgliedschaft verschenken",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Gib Feedback zu diesem Beitrag",
    "Help! I'm not receiving emails": "Hilfe! Ich erhalte keine E-Mails",
    "Here are a few other sites you may enjoy.": "Hier sind ein paar andere Websites, die dir gefallen könnten.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Wenn ein Newsletter als Spam markiert wird, werden E-Mails für diese Adresse automatisch deaktiviert, um sicherzustellen, dass du keine unerwünschten Nachrichten mehr erhältst.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Wenn die Spam-Beschwerde versehentlich war oder du wieder E-Mails erhalten möchtest, kannst du dich durch Klicken auf den Button auf dem vorherigen Bildschirm erneut für E-Mails anmelden.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Wenn du dein Abonnement jetzt kündigst, hast du noch bis zum {periodEnd} Zugang.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Wenn du eine Firmen- oder Regierungs-E-Mail-Adresse nutzt, wende dich an deine IT-Abteilung und bitte sie, E-Mails von {senderEmail} zu erlauben",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Ein Login-Link wurde an deine E-Mail-Adresse gesendet. Falls die E-Mail nicht innerhalb von 3 Minuten ankommt, überprüfe bitte deinen Spam-Ordner.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "Eine E-Mail wurde an {submittedEmailOrInbox} gesendet. Klicke auf den Link in der E-Mail oder gib den Code unten ein.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Wenn du wieder E-Mails erhalten möchtest, solltest du deine hinterlegte E-Mail-Adresse auf Probleme überprüfen und dann auf dem vorherigen Bildschirm auf \"erneut abonnieren\" klicken.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Wenn du den Newsletter, für den du dich angemeldet hast, nicht erhältst, gibt es einige Dinge, die du überprüfen kannst.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Wenn du all diese Punkte erledigt hast und immer noch keine E-Mails erhältst, kannst du Unterstützung erhalten, indem du dich an {supportAddress} wendest.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Im Falle eines dauerhaften Fehlers beim Versuch, einen Newsletter zu senden, werden die E-Mails auf dem Konto deaktiviert.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Füge in deinem E-Mail-Client {senderEmail} zu deiner Kontaktliste hinzu. Dies signalisiert deinem Mail-Anbieter, dass E-Mails von dieser Adresse vertrauenswürdig sind.",
    "Invalid email address": "Ungültige E-Mail-Adresse",
    "Invalid verification code": "Ungültiger Bestätigungscode",
    "Jamie Larson": "Jamie Larson",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "Weniger davon",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Stelle sicher, dass E-Mails nicht unbeabsichtigt im Spam-Ordner deines Posteingangs landen. Wenn das der Fall sein sollte, klicke auf \"Kein Spam\" und/oder \"In den Posteingang bewegen\".",
    "Manage": "Verwalten",
    "Maybe later": "Vielleicht später",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "Mitgliedschaften aus dieser E-Mail-Domain sind momentan eingeschränkt.",
    "Memberships unavailable, contact the owner for access.": "Mitgliedschaft nicht verfügbar. Kontaktiere den/die Besitzer*in für Zugang.",
    "month": "Monat",
    "Monthly": "Monatlich",
    "More like this": "Mehr davon",
    "More options": "",
    "Name": "Name",
    "Need more help? Contact support": "Du benötigst weitere Hilfe? Kontaktiere den Support",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Newsletter können aus zwei Gründen in deinem Konto deaktiviert werden: Eine frühere E-Mail wurde als Spam markiert oder der Versuch, eine E-Mail zu senden, führte zu einem dauerhaften Fehler (Bounce).",
    "No member exists with this e-mail address.": "Mit dieser E-Mail Adresse existiert kein Mitglied.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Keine E-Mails erhalten?",
    "Now": "",
    "Now check your email!": "Überprüfe jetzt deinen Posteingang!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Wenn du nach der Registrierung immer noch keine E-Mails in deinem Posteingang siehst, überprüfen deinen Spam-Ordner. Einige E-Mail-Anbieter speichern frühere Spam-Beschwerden und kennzeichnen E-Mails weiterhin. Wenn dies der Fall ist, markiere den neuesten Newsletter als \"Kein Spam\", um ihn wieder in deinen Posteingang zu verschieben.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Permanenter Fehler (Bounce)",
    "Phone number": "Telefonnummer",
    "Plan": "Tarif",
    "Plan checkout was cancelled.": "Der Abschluss des Tarifs wurde abgebrochen.",
    "Plan upgrade was cancelled.": "Das Upgrade deines Tarifs wurde abgebrochen.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Bitte kontaktiere {supportAddress}, um dein kostenloses Abonnement zu bearbeiten.",
    "Please enter {fieldName}": "Bitte gib eine/n {fieldName} ein",
    "Please fill in required fields": "Bitte alle Pflichtfelder ausfüllen",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "E-Mails wieder aktivieren",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Empfehlungen",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Wird zum Preis von {price} verlängert.",
    "Resume subscription": "",
    "Retry": "Nochmals versuchen",
    "Save": "Speichern",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Login-Link senden...",
    "Sending...": "Sende...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Alle anzeigen",
    "Sign in": "Einloggen",
    "Sign out": "Abmelden",
    "Sign up": "Registrieren",
    "Signup error: Invalid link": "Fehler bei der Registrierung: Ungültiger Link",
    "Signups from this email domain are currently restricted.": "Registrierungen über diese E-Mail-Domain sind aktuell nicht möglich.",
    "Something went wrong, please try again later.": "Etwas ist schief gelaufen, bitte versuche es später noch einmal.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Entschuldige, aktuell sind keine Empfehlungen verfügbar.",
    "Sorry, that didn’t work.": "Entschuldige, das hat nicht funktioniert.",
    "Spam complaints": "Spam-Beschwerden",
    "Start {amount}-day free trial": "Auswählen",
    "Starting {startDate}": "Beginnt am {startDate}",
    "Starting today": "Beginnt heute",
    "State": "",
    "Submit feedback": "Feedback senden",
    "Subscribe": "Abonnieren",
    "Subscribed": "Abonniert",
    "Subscription plan updated successfully": "Abonnement wurde erfolgreich aktualisiert",
    "Success": "Erfolg",
    "Success! Check your email for magic link to sign-in.": "Super! Sieh in deinem Posteingang nach und klicke zum Einloggen auf den magischen Link.",
    "Success! Your account is fully activated, you now have access to all content.": "Prima! Dein Konto ist nun vollständig und du hast jetzt Zugang zu allen Inhalten.",
    "Success! Your email is updated.": "Super! Deine E-Mail wurde erfolgreich aktualisiert.",
    "Successfully unsubscribed": "Erfolgreich abgemeldet",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Danke fürs Abonnieren. Unten findest du noch ein paar weitere Websites, die dir gefallen könnten.",
    "Thank you for your support": "Vielen Dank für Deine Unterstützung",
    "Thank you for your support!": "Vielen Dank für Deine Unterstützung!",
    "Thanks for the feedback!": "Danke für das Feedback!",
    "That didn't go to plan": "Das ist nicht nach Plan verlaufen",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Die E-Mail-Adresse, die wir von dir haben, lautet {memberEmail} - wenn das nicht korrekt ist, kannst du sie in deinen <button>Kontoeinstellungen</button> aktualisieren.",
    "There was a problem submitting your feedback. Please try again a little later.": "Bei der Übermittlung deines Feedbacks ist ein Problem aufgetreten. Bitte versuche es etwas später noch einmal.",
    "There was an error cancelling your subscription, please try again.": "Beim Kündigen deines Abonnements ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    "There was an error continuing your subscription, please try again.": "Beim Erneuern deines Abonnements ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    "There was an error processing your payment. Please try again.": "Bei der Verarbeitung deiner Zahlung gab es einen Fehler. Bitte versuche es noch einmal.",
    "There was an error sending the email, please try again": "Beim Versand der E-Mail ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Für diese Seite benötigst du eine Einladung. Bitte kontaktiere den Inhaber.",
    "This site is not accepting donations at the moment.": "Diese Website nimmt derzeit keine Spenden entgegen.",
    "This site is not accepting payments at the moment.": "Diese Website nimmt zur Zeit keine Zahlungen entgegen.",
    "This site only accepts paid members.": "Diese Seite ist exklusiv für zahlende Mitglieder.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Um deine Registrierung abzuschließen, klicke auf den Bestätigungslink in deinem Posteingang. Falls die E-Mail nicht innerhalb von 3 Minuten ankommt, überprüfe bitte deinen Spam-Ordner!",
    "To continue to stay up to date, subscribe to {publication} below.": "Abonniere unten {publication}, um auf dem Laufenden zu bleiben.",
    "Too many attempts try again in {number} days.": "Zu viele Versuche. Versuche es in {number} Tagen erneut.",
    "Too many attempts try again in {number} hours.": "Zu viele Versuche. Versuche es in {number} Stunden erneut.",
    "Too many attempts try again in {number} minutes.": "Zu viele Versuche. Versuche es in {number} Minuten erneut.",
    "Too many different sign-in attempts, try again in {number} days": "Zu viele verschiedene Anmeldeversuche. Versuche es in {number} Tagen erneut.",
    "Too many different sign-in attempts, try again in {number} hours": "Zu viele verschiedene Anmeldeversuche. Versuche es in {number} Stunden erneut.",
    "Too many different sign-in attempts, try again in {number} minutes": "Zu viele verschiedene Anmeldeversuche. Versuche es in {number} Minuten erneut.",
    "Too many sign-up attempts, try again later": "Zu viele Anmeldeversuche. Versuche es später erneut.",
    "Try free for {amount} days, then {originalPrice}.": "Kostenfreier Testzugang für {amount} Tage, danach {originalPrice}.",
    "Unable to initiate checkout session": "Zahlungsabwicklung konnte nicht gestartet werden",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Schalte den Zugang zu allen Newslettern frei, indem du zahlende/r Abonnent*in wirst.",
    "Unsubscribe from all emails": "Von allen E-Mails abmelden",
    "Unsubscribed": "Abmelden",
    "Unsubscribed from all emails.": "Von allen E-Mails abgemeldet",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Wenn du dich von diesen E-Mails abmeldest, wird dein bezahltes Abonnement bei {title} nicht automatisch gekündigt",
    "Update": "Aktualisieren",
    "Update your preferences": "Aktualisiere deine Einstellungen",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Verifizierungs-Link gesendet — überprüfe deinen Posteingang",
    "Verify your email address is correct": "Überprüfe, ob deine E-Mail-Adresse stimmt",
    "Verifying...": "Verifiziere...",
    "View plans": "Tarife ansehen",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Wir konnten dich nicht abmelden, da die E-Mail-Adresse nicht gefunden wurde. Bitte kontaktiere den/dir Seitenbetreiber*in.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Willkommen zurück, {name}!",
    "Welcome back!": "Willkommen zurück!",
    "Welcome to {siteTitle}": "Willkommen bei {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Wenn ein Posteingang eine E-Mail nicht annimmt, spricht man von einem Bounce. In vielen Fällen kann dies vorübergehend sein (Soft Bounce). In einigen Fällen kann eine E-Mail jedoch als dauerhafter Fehler zurückgeschickt werden, wenn eine E-Mail-Adresse ungültig oder nicht vorhanden ist (Hard Bounce).",
    "Why has my email been disabled?": "Warum wurde meine E-Mail deaktiviert?",
    "X (Twitter)": "",
    "year": "Jahr",
    "Yearly": "Jährlich",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Du hast derzeit eine kostenlose Mitgliedschaft. Wechsle zu einem kostenpflichtigen Abonnement, um vollen Zugang zu erhalten.",
    "You have been successfully resubscribed": "Du wurdest erfolgreich wieder angemeldet",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Du erhältst im Moment keine E-Mails",
    "You're not receiving emails": "Du erhältst keine E-Mails",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Du erhältst keine E-Mails, da du entweder eine kürzlich empfangene Nachricht als Spam markiert hast oder weil Nachrichten nicht an deine angegebene E-Mail-Adresse zugestellt werden konnten.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Du hast dich erfolgreich angemeldet.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Du hast dich erfolgreich angemeldet bei <strong>{siteTitle}</strong>",
    "Your account": "Dein Konto",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Deine E-Mailadresse konnte nicht angemeldet werden. Bitte versuche es noch einmal.",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "Dein Posteingang",
    "Your input helps shape what gets published.": "Dein Beitrag trägt dazu bei, was veröffentlicht wird.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Dein Abonnement wird am {expiryDate} ablaufen.",
    "Your subscription will renew on {renewalDate}": "Dein Abonnement wird am {renewalDate} erneuert.",
    "Your subscription will start on {subscriptionStart}": "Dein Abonnement started am {subscriptionStart}."
}
